import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import WarningBox from '../common/WarningBox';

const propTypes = {
	kickerName: PropTypes.string,
	secondsTilClose: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	unsavedChanges: PropTypes.bool,
};
const defaultProps = {
	kickerName: '',
	unsavedChanges: false,
};

class ForceCloseEditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
        }

        this.close = this.close.bind(this);
    }

    close() {
        this.setState({ show: false });
    }

    render() {
    	return (
            <Modal
                show={this.state.show}
                size="lg"
                enforceFocus
                autoFocus
                backdrop="static"
                animation={false}
                onHide={this.close}
            >
                <Modal.Body>
                    <WarningBox className="static-warning">
                        <div>
                            <p>{'Editing lock is being cleared by admin ' + (this.props.kickerName || '') + '.'}</p>
                            <p>{(this.props.unsavedChanges) ? 
                            	'Please save (if desired) and close now.'
                            	:
                            	'Please close the edit session now.'
                            }</p>
                            <p>{'This edit session will automatically close in ' + this.props.secondsTilClose + ' seconds.'}</p>
                        </div>
                    </WarningBox>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>
                        Hide warning
                    </Button>
                </Modal.Footer>
            </Modal>
    	);
    }
}

ForceCloseEditModal.propTypes = propTypes;
ForceCloseEditModal.defaultProps = defaultProps;

export default ForceCloseEditModal;